import React from "react";
import { List, Box } from "native-base";


export { FlatList,  } from "native-base";
export { List };

const Item = List.Item;
List.Item = React.memo(({unstyled, style, ...props}) => {
    if (unstyled) {
        return (
            <Box pl="8px" flex="1" display="inline" { ...props} />
        )
    }
    
    return (
        <Item style={style} { ...props}>
            <Box flex="1" display="inline">{props.children}</Box>
        </Item>
    )
});
